<prism-select
  [selectOptions]="options"
  [label]="label"
  placeHolder="Select a Page Size"
  ariaLabel="Items per page"
  [control]="pageSizeControl"
  [required]="required"
  [readOnly]="readOnly"
  [allowDeselect]="false"
  [labelClass]="labelClass">
</prism-select>

